module.exports = __webpack_public_path__ + "img/footlogo.2c682c5c.png";